import { render } from "./PatientProfile.vue?vue&type=template&id=b1be3046&ts=true"
import script from "./PatientProfile.ts?vue&type=script&lang=ts&external"
export * from "./PatientProfile.ts?vue&type=script&lang=ts&external"

import "./PatientProfile.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__